export default [
    {
        path: '/about-us',
        name: 'about',
        component: () => import('./components/main-view.vue'),
        meta: { 
            title: 'About Us'
        }, 
    }
]